import {
    /** FETCH APPLICATION  */
    FETCH_ASSESSAPPLICATION_FULFILLED,
    FETCH_ASSESSAPPLICATION_REJECTED,
    FETCH_ASSESSAPPLICATION_PENDING,
    RESET_ASSESSAPPLICATION
} from "../../actions/v3/assessApplication";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ASSESSAPPLICATION_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_ASSESSAPPLICATION_FULFILLED:
            return {
                ...state,
                assessApplication: action.payload,
                done: true,
                spinner: false
            };
        case FETCH_ASSESSAPPLICATION_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_ASSESSAPPLICATION:
            return {
                done: false,
                error: false,
                spinner: false
            };
        default:
            return state;
    }
};